export const iconFontAwesomeDisasterCrisisHillRockslide = (
	<i className="fa-solid fa-hill-rockslide"></i>
);
